<template>
  <v-container
    grid-list-xl
  >
    <v-form>
      <v-layout
        v-if="hasAction('view_settings') || isAdmin()"
        layout
        wrap>
        <v-flex
          xs12
          sm6
          md6
        >
          <v-textarea
            v-model="hdBankPublicKey"
            :label="$t('lienVietConfig.merchantPublicKey')"
            rows="4"
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md6
        >
          <v-textarea
            v-model="hdBankPublicKeySent"
            :label="$t('HDBankKeySetting.HDBankPublicKey')"
            rows="4"
          />
        </v-flex>
        <v-flex
          xs12
          sm12
          md12>
          <span style="overflow-wrap: break-word;">
            {{ $t('lienVietConfig.WAPUrl') }}
            <v-tooltip
              top>
              <template v-slot:activator="{ on }">
                <v-icon
                  class="ml-2"
                  v-on="on"
                  @click="onCopyText(getWAPUrl())">mdi-content-copy</v-icon>
              </template>
              <span v-if="!urlCopied">{{ $t('entity.copyUrl') }}</span>
              <span
                v-else
                style="overflow-wrap: break-word;">{{ $t('entity.copied') }}: {{ urlCopied }}</span>
            </v-tooltip>
          </span>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="hasAction('update_settings') || isAdmin()"
        style="margin-left: 0;"
        color="error darken-1"
        @click="onShowInputDialog"
      >
        <span class="btn-label mr-3">
          <i class="glyphicon glyphicon-edit" />
        </span>
        <span style="text-transform: none;">{{ $t("lienVietConfig.merchantPrivateKey") }} </span>
      </v-btn>
      <v-btn
        v-if="hasAction('update_settings') || isAdmin()"
        style="margin-right: 0;"
        class="pull-right"
        color="success"
        @click="onCreateSettingConfig"
      >
        <span class="btn-label mr-3">
          <i class="glyphicon glyphicon-ok" />
        </span>
        <span style="text-transform: none;">{{ $t("common.save") }} </span>
      </v-btn>
    </v-form>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import stringUtils from 'utils/stringUtils'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
export default {
  components: {},
  data: () => ({
    objectSettingKey: stringUtils.ObjectSettingKey,
    hdBankPublicKey: null,
    hdBankPrivateKey: null,
    hdBankPublicKeySent: null,
    urlCopied: null
  }),
  computed: {
    ...mapGetters([
      'GET_SNACK_BAR',
      'GET_CURRENT_ACCOUNT'
    ])
  },
  created () {
    this.getHDBankPublicKeySent()
    this.getHDBankPublicKey()
  },
  methods: {
    /**
     * Get url
     */
    getWAPUrl: function () {
      return functionUtils.removeDoubleSlashesFromUrl(process.env.VUE_APP_BACKEND_PROD_URL + '/api/v1/portal/bank_transfer/hd_bank_transfer/')
    },
    /**
     * Copy text
     */
    onCopyText: function (text) {
      navigator.clipboard.writeText(text)
      this.urlCopied = text
    },
    getHDBankPublicKey: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.HD_BANK_PUBLIC_KEY
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.hdBankPublicKey = data[0].value
          }
        }.bind(this)
      )
    },
    /**
     * Get Bao Kim public key
     */
    getHDBankPublicKeySent: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.HD_BANK_PUBLIC_KEY_SENT
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.hdBankPublicKeySent = data[0].value
          }
        }.bind(this)
      )
    },
    // Check is admin
    isAdmin: function () {
      return functionUtils.isAdmin(this.GET_CURRENT_ACCOUNT)
    },
    /**
     * Has action
     */
    hasAction: function (metaCode) {
      return functionUtils.hasAction(this.GET_CURRENT_ACCOUNT, metaCode)
    },
    /**
     * create setting config
     */
    createSettingConfig: function (key, value) {
      let filter = {
        objectId: null,
        objectType: 'System',
        key: key,
        value: value
      }
      this.CREATE_OBJECT_SETTING(filter)
    },

    /**
     * Create or update dh bank config
     */
    onCreateSettingConfig: function (event) {
      event.preventDefault()
      this.createSettingConfig(this.objectSettingKey.HD_BANK_PUBLIC_KEY, this.hdBankPublicKey)
      this.createSettingConfig(this.objectSettingKey.HD_BANK_PUBLIC_KEY_SENT, this.hdBankPublicKeySent)
      this.ON_SHOW_TOAST({
        message: this.$t('server.common.successed'),
        styleType: ToastType.SUCCESS
      })
    },
    onShowInputDialog: function () {
      this.$message.prompt({
        message: this.$t('lienVietConfig.merchantPrivateKey'),
        inputTitle: this.$t('lienVietConfig.merchantPrivateKey'),
        inputLines: 3,
        prependIcon: 'mdi-key-change',
        onConfirm: (text) => {
          this.onChangeMerchantPrivateKey(text)
        }
      });
    },
    onChangeMerchantPrivateKey: function (text) {
      if (!functionUtils.isEmptyString(text)) {
        this.createSettingConfig(this.objectSettingKey.HD_BANK_PRIVATE_KEY, text)
      }
    },
    ...mapActions([
      'CREATE_OBJECT_SETTING',
      'GET_OBJECT_SETTING',
      'ON_SHOW_TOAST'
    ])
  }
}
</script>

<style>

</style>
